module.exports = __webpack_public_path__ + "assets/img/29_684.260c83a0.jpg";